import { P as Popup, p as popupDefinition } from './definition67.js';
import { i as iconDefinition } from './definition28.js';
import { l as listboxOptionDefinition } from './definition37.js';
import { D as DOM, O as Observable, o as observable, a as attr, v as volatile, h as html, d as createRegisterFunction, f as defineVividComponent } from './vivid-element.js';
import { W as WithLightDOMFeedback, f as feedbackMessageDefinition } from './mixins.js';
import { L as Listbox } from './listbox.js';
import { H as HostSemantics, a as applyHostSemantics } from './host-semantics.js';
import { F as FormAssociated } from './form-associated.js';
import { i as inRange } from './numbers.js';
import { W as WithErrorText } from './with-error-text.js';
import { W as WithSuccessText } from './with-success-text.js';
import { F as FormElement } from './form-element.js';
import { A as AffixIconWithTrailing, a as affixIconTemplateFactory, I as IconWrapper } from './affix.js';
import { u as uniqueId } from './strings.js';
import { a as keySpace, b as keyEscape, c as keyTab, d as keyEnd, e as keyArrowUp, f as keyArrowDown, g as keyHome, k as keyEnter } from './key-codes.js';
import { L as ListboxOption } from './option.js';
import { c as chevronTemplateFactory } from './definition11.js';
import { h as handleEscapeKeyAndStopPropogation } from './index.js';
import { r as ref } from './ref.js';
import { w as when } from './when.js';
import { s as slotted } from './slotted.js';
import { c as classNames } from './class-names.js';

const styles = ".chevron{display:flex;flex-shrink:0;font:var(--vvd-typography-base-extended);transform:rotate(0);transition:transform .2s}:host([data-expanded=true]) .chevron,:host([open]) .chevron{transform:rotate(180deg)}:host(:focus-visible){outline:none}:host{display:inline-flex;flex-direction:column;gap:4px;--_low-ink-color: var(--vvd-color-neutral-600);--focus-stroke-gap-color: transparent}:host([disabled]){--_low-ink-color: var(--vvd-color-neutral-400);cursor:not-allowed}.label{color:var(--vvd-color-canvas-text);contain:inline-size;font:var(--vvd-typography-base)}.control{--_appearance-color-text: var(--vvd-color-canvas-text);--_appearance-color-fill: var(--vvd-color-canvas);--_appearance-color-outline: var(--vvd-color-neutral-500)}.control.appearance-ghost{--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: transparent;--_appearance-color-outline: transparent}.control:where(.hover,:hover):where(:not(.disabled,:disabled,.readonly)){--_appearance-color-text: var(--vvd-color-canvas-text);--_appearance-color-fill: var(--vvd-color-canvas);--_appearance-color-outline: var(--vvd-color-neutral-700)}.control:where(.hover,:hover):where(:not(.disabled,:disabled,.readonly)).appearance-ghost{--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: var(--_connotation-color-faint);--_appearance-color-outline: transparent}.control:where(.disabled,:disabled){--_appearance-color-text: var(--vvd-color-neutral-300);--_appearance-color-fill: var(--vvd-color-neutral-100);--_appearance-color-outline: var(--vvd-color-neutral-300)}.control:where(.disabled,:disabled).appearance-ghost{--_appearance-color-text: var(--vvd-color-neutral-300);--_appearance-color-fill: transparent;--_appearance-color-outline: transparent}.control:where(.readonly):where(:not(.disabled,:disabled)){--_appearance-color-text: var(--vvd-color-canvas-text);--_appearance-color-fill: var(--vvd-color-neutral-200);--_appearance-color-outline: var(--vvd-color-neutral-400)}.control:where(.readonly):where(:not(.disabled,:disabled)).appearance-ghost{--_appearance-color-text: var(--vvd-color-neutral-600);--_appearance-color-fill: transparent;--_appearance-color-outline: transparent}.control:where(.error):where(:not(.disabled,:disabled)){--_appearance-color-text: notSet;--_appearance-color-fill: var(--vvd-color-alert-50);--_appearance-color-outline: var(--vvd-color-alert-500)}.control:where(.error):where(:not(.disabled,:disabled)).appearance-ghost{--_appearance-color-text: notSet;--_appearance-color-fill: var(--vvd-color-alert-50);--_appearance-color-outline: transparent}.control:where(.success):where(:not(.disabled,:disabled)){--_appearance-color-text: notSet;--_appearance-color-fill: var(--vvd-color-success-50);--_appearance-color-outline: var(--vvd-color-success-500)}.control:where(.success):where(:not(.disabled,:disabled)).appearance-ghost{--_appearance-color-text: notSet;--_appearance-color-fill: var(--vvd-color-success-50);--_appearance-color-outline: transparent}.control{--_connotation-color-primary: var(--vvd-select-accent-primary, var(--vvd-color-canvas-text));--_connotation-color-primary-text: var(--vvd-select-accent-primary-text, var(--vvd-color-canvas));--_connotation-color-primary-increment: var(--vvd-select-accent-primary-increment, var(--vvd-color-neutral-800));--_connotation-color-intermediate: var(--vvd-select-accent-intermediate, var(--vvd-color-neutral-500));--_connotation-color-faint: var(--vvd-select-accent-faint, var(--vvd-color-neutral-50));--_connotation-color-soft: var(--vvd-select-accent-soft, var(--vvd-color-neutral-100));--_connotation-color-firm: var(--vvd-select-accent-firm, var(--vvd-color-canvas-text));--_connotation-color-fierce: var(--vvd-select-accent-fierce, var(--vvd-color-neutral-700))}.control{border-radius:var(--_select-control-border-radius);block-size:var(--_select-block-size);padding-inline:var(--_select-padding-inline)}.control{--_select-icon-size: calc(1px*(40 + 4*clamp(-1, var(--vvd-size-density, 0), 2))/2) ;--_select-block-size: calc(1px*(40 + 4*clamp(-1, var(--vvd-size-density, 0), 2))) ;--_select-padding-inline: calc(1px*(40 + 4*clamp(-1, var(--vvd-size-density, 0), 2))*.4) ;display:flex;align-items:center;justify-content:space-between;background-color:var(--_appearance-color-fill);box-shadow:inset 0 0 0 1px var(--_appearance-color-outline);color:var(--_appearance-color-text);font:var(--vvd-typography-base);gap:8px;transition:box-shadow .2s,background-color .2s}.control.size-condensed{--_select-icon-size: calc(1px*(40 + 4*clamp(-1, var(--vvd-size-density, 0), 2))*.4) ;--_select-block-size: calc(1px*(32 + 4*clamp(-1, var(--vvd-size-density, 0), 2))) ;--_select-padding-inline: calc(1px*(24 + 4*clamp(-1, var(--vvd-size-density, 0), 2))/2) }.control.size-condensed:not(.shape-pill){--_select-control-border-radius: 4px}.control-wrapper{position:relative}.control:not(.disabled){cursor:pointer}.control.disabled{pointer-events:none}.control:not(.shape-pill){--_select-control-border-radius: 8px}.control.shape-pill{--_select-control-border-radius: 24px}:host(:focus-visible) .control{box-shadow:0 0 0 4px color-mix(in srgb,var(--vvd-color-cta-500),transparent 85%),inset 0 0 0 3px var(--focus-stroke-gap-color, currentColor);outline:1px solid var(--focus-stroke-color, var(--vvd-color-cta-500));outline-offset:calc(-1px - var(--focus-inset, 0px))}.listbox{display:flex;max-height:var(--select-height, 408px);flex-direction:column;padding:4px;gap:2px;overflow-y:auto}:host([multiple]:focus-visible) .listbox{box-shadow:0 0 0 4px color-mix(in srgb,var(--vvd-color-cta-500),transparent 85%),inset 0 0 0 3px var(--focus-stroke-gap-color, currentColor);outline:1px solid var(--focus-stroke-color, var(--vvd-color-cta-500));outline-offset:calc(-1px - var(--focus-inset, 0px));border-radius:8px}.selected-value{display:flex;overflow:hidden;flex-grow:1;align-items:center;column-gap:12px;white-space:nowrap}.selected-value .text{overflow:hidden;max-inline-size:100%;text-overflow:ellipsis}.control.shows-placeholder .selected-value .text{color:var(--vvd-color-neutral-600)}.selected-value slot[name=icon]{flex:0 0 var(--_select-icon-size);font-size:var(--_select-icon-size);line-height:1}.control.has-meta .selected-value{padding-inline-end:8px}.feedback-wrapper{display:contents}::part(popup-base){inline-size:max-content;min-inline-size:var(--_select-fixed-width, 100%)}:host([multiple]) ::part(popup-base){position:static}";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
class Select extends WithLightDOMFeedback(
  WithErrorText(
    WithSuccessText(
      FormElement(HostSemantics(AffixIconWithTrailing(FormAssociated(Listbox))))
    )
  )
) {
  constructor() {
    super(...arguments);
    /**
     * @internal
     */
    this.proxy = document.createElement("select");
    this.activeIndex = -1;
    /**
     * The start index when checking a range of options.
     *
     * @internal
     */
    this.rangeStartIndex = -1;
    this.open = false;
    /**
     * The unique id for the internal listbox element.
     *
     * @internal
     */
    this.listboxId = uniqueId("listbox-");
    this.maxHeight = 0;
    this.fixedDropdown = false;
    this.placeholderOption = null;
    this._feedbackWrapper = null;
  }
  /**
   * Returns the last checked option.
   *
   * @internal
   */
  get activeOption() {
    return this.options[this.activeIndex];
  }
  /**
   * Returns the list of checked options.
   *
   * @internal
   */
  get checkedOptions() {
    return this.options.filter((o) => o.checked);
  }
  /**
   * Returns the index of the first selected option.
   *
   * @internal
   */
  get firstSelectedOptionIndex() {
    return this.options.indexOf(this.firstSelectedOption);
  }
  /**
   * Updates the `ariaActiveDescendant` property when the active index changes.
   *
   * @internal
   */
  activeIndexChanged(_, next) {
    this._activeDescendant = this.options[next]?.id ?? "";
    this.focusAndScrollOptionIntoView();
  }
  /**
   * Toggles the checked state for the currently active option.
   *
   * @remarks
   * Multiple-selection mode only.
   *
   * @internal
   */
  checkActiveIndex() {
    const activeItem = this.activeOption;
    if (activeItem) {
      activeItem.checked = true;
    }
  }
  /**
   * Sets the active index to the first option and marks it as checked.
   *
   * @remarks
   * Multi-selection mode only.
   *
   * @param preserveChecked - mark all options unchecked before changing the active index
   *
   * @internal
   */
  checkFirstOption(preserveChecked) {
    if (preserveChecked) {
      if (this.rangeStartIndex === -1) {
        this.rangeStartIndex = this.activeIndex + 1;
      }
      this.options.forEach((o, i) => {
        o.checked = inRange(i, this.rangeStartIndex);
      });
    } else {
      this.uncheckAllOptions();
    }
    this.activeIndex = 0;
    this.checkActiveIndex();
  }
  /**
   * Decrements the active index and sets the matching option as checked.
   *
   * @remarks
   * Multi-selection mode only.
   *
   * @param preserveChecked - mark all options unchecked before changing the active index
   *
   * @internal
   */
  checkLastOption(preserveChecked) {
    if (preserveChecked) {
      if (this.rangeStartIndex === -1) {
        this.rangeStartIndex = this.activeIndex;
      }
      this.options.forEach((o, i) => {
        o.checked = inRange(i, this.rangeStartIndex, this.length);
      });
    } else {
      this.uncheckAllOptions();
    }
    this.activeIndex = this.length - 1;
    this.checkActiveIndex();
  }
  /**
   * Increments the active index and marks the matching option as checked.
   *
   * @remarks
   * Multiple-selection mode only.
   *
   * @param preserveChecked - mark all options unchecked before changing the active index
   *
   * @internal
   */
  checkNextOption(preserveChecked) {
    if (preserveChecked) {
      if (this.rangeStartIndex === -1) {
        this.rangeStartIndex = this.activeIndex;
      }
      this.options.forEach((o, i) => {
        o.checked = inRange(i, this.rangeStartIndex, this.activeIndex + 1);
      });
    } else {
      this.uncheckAllOptions();
    }
    this.activeIndex += this.activeIndex < this.length - 1 ? 1 : 0;
    this.checkActiveIndex();
  }
  /**
   * Decrements the active index and marks the matching option as checked.
   *
   * @remarks
   * Multiple-selection mode only.
   *
   * @param preserveChecked - mark all options unchecked before changing the active index
   *
   * @internal
   */
  checkPreviousOption(preserveChecked) {
    if (preserveChecked) {
      if (this.rangeStartIndex === -1) {
        this.rangeStartIndex = this.activeIndex;
      }
      if (this.checkedOptions.length === 1) {
        this.rangeStartIndex += 1;
      }
      this.options.forEach((o, i) => {
        o.checked = inRange(i, this.activeIndex, this.rangeStartIndex);
      });
    } else {
      this.uncheckAllOptions();
    }
    this.activeIndex -= this.activeIndex > 0 ? 1 : 0;
    this.checkActiveIndex();
  }
  /**
   * @internal
   */
  focusAndScrollOptionIntoView() {
    super.focusAndScrollOptionIntoView(this.activeOption);
  }
  /**
   * In multiple-selection mode:
   * If any options are selected, the first selected option is checked when
   * the listbox receives focus. If no options are selected, the first
   * selectable option is checked.
   *
   * @internal
   */
  focusinHandler(e) {
    if (!this.multiple) {
      return super.focusinHandler(e);
    }
    if (!this.shouldSkipFocus && e.target === e.currentTarget) {
      this.uncheckAllOptions();
      if (this.activeIndex === -1) {
        this.activeIndex = this.firstSelectedOptionIndex !== -1 ? this.firstSelectedOptionIndex : 0;
      }
      this.checkActiveIndex();
      this.setSelectedOptions();
      this.focusAndScrollOptionIntoView();
    }
    this.shouldSkipFocus = false;
  }
  /**
   * Sets an option as selected and gives it focus.
   *
   * @public
   */
  setSelectedOptions() {
    if (!this.multiple) {
      super.setSelectedOptions();
      return;
    }
    if (this.$fastController.isConnected && this.options) {
      this.selectedOptions = this.options.filter((o) => o.selected);
      this.focusAndScrollOptionIntoView();
    }
  }
  /**
   * Toggles the selected state of the provided options. If any provided items
   * are in an unselected state, all items are set to selected. If every
   * provided item is selected, they are all unselected.
   *
   * @internal
   */
  toggleSelectedForAllCheckedOptions() {
    const enabledCheckedOptions = this.checkedOptions.filter(
      (o) => !o.disabled
    );
    const force = !enabledCheckedOptions.every((o) => o.selected);
    enabledCheckedOptions.forEach((o) => o.selected = force);
    this.selectedIndex = this.options.indexOf(
      enabledCheckedOptions[enabledCheckedOptions.length - 1]
    );
    this.setSelectedOptions();
    this.updateValue(true);
  }
  /**
   * @internal
   */
  typeaheadBufferChanged(prev, next) {
    if (!this.multiple) {
      super.typeaheadBufferChanged(prev, next);
      return;
    }
    if (this.$fastController.isConnected) {
      const typeaheadMatches = this.getTypeaheadMatches();
      const activeIndex = this.options.indexOf(typeaheadMatches[0]);
      if (activeIndex > -1) {
        this.activeIndex = activeIndex;
        this.uncheckAllOptions();
        this.checkActiveIndex();
      }
      this.typeaheadExpired = false;
    }
  }
  /**
   * Unchecks all options.
   *
   * @remarks
   * Multiple-selection mode only.
   *
   * @param preserveChecked - reset the rangeStartIndex
   *
   * @internal
   */
  uncheckAllOptions(preserveChecked = false) {
    this.options.forEach((o) => o.checked = false);
    if (!preserveChecked) {
      this.rangeStartIndex = -1;
    }
  }
  /**
   * Sets focus when the open property changes.
   *
   * @internal
   */
  openChanged(prev, next) {
    if (!this.collapsible) {
      return;
    }
    if (this.open) {
      this.focusAndScrollOptionIntoView();
      this.indexWhenOpened = this.selectedIndex;
      DOM.queueUpdate(() => this.focus());
      return;
    }
    const didClose = prev === true && next === false;
    const selectionChangedWhileOpen = this.indexWhenOpened !== this.selectedIndex;
    if (didClose && selectionChangedWhileOpen) {
      this.updateValue(true);
    }
  }
  get collapsible() {
    return !this.multiple;
  }
  /**
   * @internal
   */
  valueChanged(prev, next) {
    let nextValue = next;
    if (this.length) {
      const selectedIndex = this._options.findIndex((el) => el.value === next);
      const prevSelectedValue = this._options[this.selectedIndex]?.value ?? null;
      const nextSelectedValue = this._options[selectedIndex]?.value ?? null;
      if (selectedIndex === -1 || prevSelectedValue !== nextSelectedValue) {
        nextValue = "";
        this.selectedIndex = selectedIndex;
      }
      nextValue = this.firstSelectedOption?.value ?? nextValue;
    }
    if (next !== nextValue) {
      this.value = nextValue;
      return;
    }
    super.valueChanged(prev, next);
    this.updateDisplayValue();
  }
  /**
   * Sets the value and display value to match the first selected option.
   *
   * @param shouldEmit - if true, the input and change events will be emitted
   *
   * @internal
   */
  updateValue(shouldEmit) {
    if (this.$fastController.isConnected) {
      this.value = this.firstSelectedOption?.value ?? "";
    }
    if (shouldEmit) {
      this.$emit("input");
      this.$emit("change", this, {
        bubbles: true,
        composed: void 0
      });
    }
  }
  /**
   * Updates the proxy value when the selected index changes.
   *
   * @param prev - the previous selected index
   * @param next - the next selected index
   *
   * @internal
   */
  selectedIndexChanged(prev, next) {
    super.selectedIndexChanged(prev, next);
    this.updateValue();
  }
  /**
   * Handle opening and closing the listbox when the select is clicked.
   *
   * @param e - the mouse event
   * @internal
   */
  clickHandler(e) {
    if (this.disabled) {
      return;
    }
    const clickedOption = e.target.closest(
      `option,[role=option],[data-vvd-component=option]`
    );
    if (clickedOption && clickedOption.disabled) {
      return;
    }
    if (this.multiple) {
      this.uncheckAllOptions();
      this.activeIndex = this.options.indexOf(clickedOption);
      this.checkActiveIndex();
      this.toggleSelectedForAllCheckedOptions();
    } else {
      super.clickHandler(e);
    }
    if (this.collapsible) {
      this.open = !this.open;
    }
    return true;
  }
  /**
   * Handles focus state when the element or its children lose focus.
   *
   * @param e - The focus event
   * @internal
   */
  focusoutHandler(e) {
    if (this.multiple) {
      this.uncheckAllOptions();
    }
    if (!this.open) {
      return true;
    }
    const focusTarget = e.relatedTarget;
    if (this.isSameNode(focusTarget)) {
      this.focus();
      return;
    }
    if (!this.options.includes(focusTarget)) {
      this.open = false;
      if (this.indexWhenOpened !== this.selectedIndex) {
        this.updateValue(true);
      }
    }
  }
  /**
   * Updates the value when an option's value changes.
   *
   * @param source - the source object
   * @param propertyName - the property to evaluate
   *
   * @internal
   */
  handleChange(source, propertyName) {
    super.handleChange(source, propertyName);
    if (propertyName === "value") {
      this.updateValue();
    }
  }
  /**
   * Prevents focus when a scrollbar is clicked.
   *
   * @param e - the mouse event object
   *
   * @internal
   */
  mousedownHandler(e) {
    if (e.offsetX >= 0 && e.offsetX <= this.listbox.scrollWidth) {
      return super.mousedownHandler(e);
    }
    return this.collapsible;
  }
  /**
   * @internal
   */
  multipleChanged(_, next) {
    this.options.forEach((o) => {
      o.checked = next ? false : void 0;
    });
    this.setSelectedOptions();
    if (this.proxy) {
      this.proxy.multiple = next;
    }
  }
  /**
   * Updates the selectedness of each option when the list of selected options changes.
   *
   * @param prev - the previous list of selected options
   * @param next - the current list of selected options
   *
   * @internal
   */
  selectedOptionsChanged(prev, next) {
    super.selectedOptionsChanged(prev, next);
    this.options.forEach((o, i) => {
      const proxyOption = this.proxy.options.item(i);
      if (proxyOption) {
        proxyOption.selected = o.selected;
      }
    });
  }
  /**
   * Resets and fills the proxy to match the component's options.
   *
   * @internal
   */
  setProxyOptions() {
    if (this.proxy instanceof HTMLSelectElement && this.options) {
      this.proxy.length = 0;
      this.options.forEach((option) => {
        const proxyOption = option.proxy || (option instanceof HTMLOptionElement ? option.cloneNode() : null);
        if (proxyOption) {
          this.proxy.options.add(proxyOption);
        }
      });
    }
  }
  /**
   * Handles keydown actions when the select is in multiple selection mode.
   *
   * @internal
   */
  multipleKeydownHandler(e) {
    if (this.disabled) {
      return;
    }
    const { key, shiftKey } = e;
    this.shouldSkipFocus = false;
    switch (key) {
      case keyHome: {
        this.checkFirstOption(shiftKey);
        return;
      }
      case keyArrowDown: {
        this.checkNextOption(shiftKey);
        return;
      }
      case keyArrowUp: {
        this.checkPreviousOption(shiftKey);
        return;
      }
      case keyEnd: {
        this.checkLastOption(shiftKey);
        return;
      }
      case keyTab: {
        this.focusAndScrollOptionIntoView();
        return;
      }
      case keyEscape: {
        this.uncheckAllOptions();
        this.checkActiveIndex();
        return;
      }
      case keySpace: {
        e.preventDefault();
        if (this.typeaheadExpired) {
          this.toggleSelectedForAllCheckedOptions();
          return;
        }
      }
      default: {
        if (key.length === 1) {
          this.handleTypeAhead(`${key}`);
        }
        return;
      }
    }
  }
  /**
   * Handle keyboard interaction for the select.
   *
   * @param e - the keyboard event
   * @internal
   */
  keydownHandler(e) {
    const selectedIndexBefore = this.selectedIndex;
    if (this.multiple) {
      this.multipleKeydownHandler(e);
    } else {
      super.keydownHandler(e);
    }
    const key = e.key;
    switch (key) {
      case keySpace: {
        e.preventDefault();
        if (this.collapsible && this.typeaheadExpired) {
          this.open = !this.open;
        }
        break;
      }
      case keyHome:
      case keyEnd: {
        e.preventDefault();
        break;
      }
      case keyEnter: {
        e.preventDefault();
        this.open = !this.open;
        break;
      }
      case keyEscape: {
        if (this.collapsible && this.open) {
          e.preventDefault();
          this.open = false;
        }
        break;
      }
      case keyTab: {
        if (this.collapsible && this.open) {
          e.preventDefault();
          this.open = false;
        }
        return true;
      }
    }
    if (this.collapsible && !this.open && this.selectedIndex !== selectedIndexBefore) {
      this.updateValue(true);
    }
    return !(e.key === keyArrowDown || e.key === keyArrowUp);
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("focusout", this.focusoutHandler);
    this.addEventListener("contentchange", this.updateDisplayValue);
  }
  disconnectedCallback() {
    this.removeEventListener("focusout", this.focusoutHandler);
    this.removeEventListener("contentchange", this.updateDisplayValue);
    super.disconnectedCallback();
  }
  /**
   *
   * @internal
   */
  updateDisplayValue() {
    if (this.collapsible) {
      Observable.notify(this, "displayValue");
    }
  }
  get displayValue() {
    Observable.track(this, "displayValue");
    return this.firstSelectedOption?.getAttribute("label") ?? this.firstSelectedOption?.text ?? this.placeholder ?? "";
  }
  setDefaultSelectedOption() {
    const options = Array.from(this.children).filter(
      Listbox.slottedOptionFilter
    );
    const selectedIndex = options.findIndex(
      (el) => el.hasAttribute("selected") || el.selected || el.value === this.value
    );
    if (selectedIndex === -1 && !this.placeholderOption) {
      this.selectedIndex = 0;
      return;
    }
    if (selectedIndex !== -1 || this.placeholder !== "") {
      this.selectedIndex = selectedIndex;
      return;
    }
  }
  /*
   * @internal
   */
  slottedOptionsChanged(prev, next) {
    this.options.forEach((o) => {
      const notifier = Observable.getNotifier(o);
      notifier.unsubscribe(this, "value");
    });
    super.slottedOptionsChanged(prev, next);
    this.options.forEach((o) => {
      const notifier = Observable.getNotifier(o);
      notifier.subscribe(this, "value");
    });
    this.setProxyOptions();
    this.updateValue();
    const scale = this.getAttribute("scale") || this.scale;
    next.forEach((element) => {
      if (scale) {
        element.setAttribute("scale", scale);
        element.scale = scale;
      }
    });
    this.proxy.value = this.value;
    this.validate();
  }
  formResetCallback() {
    this.setProxyOptions();
    super.setDefaultSelectedOption();
    if (this.selectedIndex === -1) {
      this.selectedIndex = 0;
    }
    if (this.placeholder) {
      this.selectedIndex = -1;
    }
  }
}
__decorateClass([
  observable
], Select.prototype, "activeIndex", 2);
// @ts-expect-error Type is incorrectly non-optional
__decorateClass([
  attr({ mode: "boolean" })
], Select.prototype, "multiple", 2);
__decorateClass([
  attr({ attribute: "open", mode: "boolean" })
], Select.prototype, "open", 2);
__decorateClass([
  volatile
], Select.prototype, "collapsible", 1);
__decorateClass([
  observable
], Select.prototype, "control", 2);
__decorateClass([
  observable
], Select.prototype, "maxHeight", 2);
__decorateClass([
  observable
], Select.prototype, "_anchor", 2);
__decorateClass([
  attr()
], Select.prototype, "scale", 2);
__decorateClass([
  attr
], Select.prototype, "appearance", 2);
__decorateClass([
  attr
], Select.prototype, "shape", 2);
__decorateClass([
  attr({ mode: "boolean", attribute: "fixed-dropdown" })
], Select.prototype, "fixedDropdown", 2);
__decorateClass([
  attr
], Select.prototype, "placeholder", 2);
__decorateClass([
  observable
], Select.prototype, "placeholderOption", 2);
__decorateClass([
  observable
], Select.prototype, "_feedbackWrapper", 2);
__decorateClass([
  observable
], Select.prototype, "metaSlottedContent", 2);

const getStateClasses = ({
  shape,
  disabled,
  appearance,
  metaSlottedContent,
  errorValidationMessage,
  successText,
  placeholder,
  value,
  scale
}) => classNames(
  ["disabled", disabled],
  [`appearance-${appearance}`, Boolean(appearance)],
  [`shape-${shape}`, Boolean(shape)],
  ["has-meta", Boolean(metaSlottedContent?.length)],
  ["error", Boolean(errorValidationMessage)],
  ["success", !!successText],
  ["shows-placeholder", Boolean(placeholder) && !value],
  [`size-${scale}`, Boolean(scale)]
);
function renderLabel() {
  return html` <label
		for="${(x) => x.multiple ? null : "control"}"
		class="label"
		id="label"
	>
		${(x) => x.label}
	</label>`;
}
function renderPlaceholder(context) {
  const optionTag = context.tagFor(ListboxOption);
  return html`
		<${optionTag} ${ref("placeholderOption")}
			text="${(x) => x.placeholder}" hidden disabled>
		</${optionTag}>`;
}
function selectValue(context) {
  const affixIconTemplate = affixIconTemplateFactory(context);
  const chevronTemplate = chevronTemplateFactory(context);
  return html` <div
		class="control ${getStateClasses}"
		${ref("_anchor")}
		id="control"
		?disabled="${(x) => x.disabled}"
	>
		<div class="selected-value">
			${(x) => affixIconTemplate(x.icon, IconWrapper.Slot)}
			<span class="text">${(x) => x.displayValue}</span>
			<slot name="meta" ${slotted("metaSlottedContent")}></slot>
		</div>
		${chevronTemplate}
	</div>`;
}
function setFixedDropdownVarWidth(x) {
  return x.open && x.fixedDropdown ? `--_select-fixed-width: ${Math.round(x.getBoundingClientRect().width)}px` : null;
}
function renderControl(context) {
  const popupTag = context.tagFor(Popup);
  return html`
			${when((x) => x.label, renderLabel())}
			<div class="control-wrapper">
				${when((x) => !x.multiple, selectValue(context))}
				<${popupTag} class="popup"
					style="${setFixedDropdownVarWidth}"
					?open="${(x) => x.collapsible ? x.open : true}"
					:anchor="${(x) => x._anchor}"
					placement="bottom-start"
					strategy="${(x) => x.fixedDropdown ? null : "absolute"}">
					<div class="listbox"
						id="${(x) => x.listboxId}"
						role="listbox"
						aria-multiselectable="${(x) => x.multiple}"
						aria-label="${(x) => x.multiple && !x.label && x.ariaLabel ? x.ariaLabel : null}"
						aria-labelledby="${(x) => x.multiple && x.label ? "label" : null}"
						?disabled="${(x) => x.disabled}"
						?hidden="${(x) => x.collapsible ? !x.open : false}"
						${ref("listbox")}>
						${when((x) => x.placeholder, renderPlaceholder(context))}
						<slot
							${slotted({
    filter: Listbox.slottedOptionFilter,
    flatten: true,
    property: "slottedOptions"
  })}>
						</slot>
				 	</div>
				</${popupTag}>
			</div>
		`;
}
function ifNotFromFeedback(handler) {
  return (x, c) => {
    if (!c.event.composedPath().includes(x._feedbackWrapper)) {
      return handler(x, c.event);
    }
    return true;
  };
}
const SelectTemplate = (context) => {
  return html`
		<template
			class="base"
			${applyHostSemantics({
    role: "combobox",
    ariaLabel: (x) => x.ariaLabel ?? x.label,
    ariaHasPopup: (x) => x.collapsible ? "listbox" : "false",
    ariaExpanded: (x) => x.open,
    ariaDisabled: (x) => x.disabled
  })}
			aria-controls="${(x) => x.listboxId}"
			aria-activedescendant="${(x) => x._activeDescendant}"
			aria-describedby="${(x) => x._feedbackDescribedBy}"
			tabindex="${(x) => !x.disabled ? "0" : null}"
			@click="${ifNotFromFeedback((x, e) => x.clickHandler(e))}"
			@focusin="${ifNotFromFeedback((x, e) => x.focusinHandler(e))}"
			@focusout="${ifNotFromFeedback(
    (x, e) => x.focusoutHandler(e)
  )}"
			@keydown="${ifNotFromFeedback((x, e) => {
    x.open && handleEscapeKeyAndStopPropogation(e);
    return x.keydownHandler(e);
  })}"
			@mousedown="${ifNotFromFeedback(
    (x, e) => x.mousedownHandler(e)
  )}"
		>
			${renderControl(context)}
			<div class="feedback-wrapper" ${ref("_feedbackWrapper")}>
				${(x) => x._getFeedbackTemplate(context)}
			</div>
		</template>
	`;
};

const selectDefinition = defineVividComponent(
  "select",
  Select,
  SelectTemplate,
  [
    popupDefinition,
    iconDefinition,
    listboxOptionDefinition,
    feedbackMessageDefinition
  ],
  {
    styles
  }
);
const registerSelect = createRegisterFunction(selectDefinition);

export { Select as S, registerSelect as r, selectDefinition as s };
